import React from 'react'
import { Grid, Row } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
  
 export default class Dashboard extends React.Component {


    componentDidMount() {
    }
  
    onClick(e) {
      var i;
      var x = document.getElementsByClassName("button-dashboard");
      for (i = 0; i < x.length; i++) {
        x[i].style.fontWeight = "normal";
      }
      x[e-1].style.fontWeight = "bold";
      this.props.callback(e)
    }
  
    render() {
      return (
          <Grid>
            <Row className='licensesLinksTop'>
              <FontAwesome name="key" size='2x' />
              <div className='dashboarddiv'>
                Licenties
              </div>
            </Row>
            <Row className='licensesLinksBottom'>
              <FontAwesome name="none" className={''}  />
              <button onClick={() => this.onClick(1)} style={{marginLeft:"42px"}} className='button-dashboard'>
                Gebruikeraccount wijzigen
              </button>
              <button onClick={() => this.onClick(2)} className='button-dashboard' >
                Ontkoppelbaar maken
              </button>
              <button onClick={() => this.onClick(3)} className='button-dashboard' >
                Licentie blokkeren
              </button>
              <button onClick={() => this.onClick(4)} className='button-dashboard' >
                Order blokkeren
              </button>
              <button onClick={() => this.onClick(5)} className='button-dashboard' >
                Producten verrijken
              </button>
              <button onClick={() => this.onClick(6)} className='button-dashboard' >
                Activatiegraad
              </button>
              <button onClick={() => this.onClick(7)} className='button-dashboard'>
                Licentieoverzicht
              </button>
            </Row>
            <Row className='DashboardBottomLine'>
            <FontAwesome name="none" className={''} size='2x' style={{marginLeft:"10px", marginBottom:"7px", marginTop:"10px", marginRight:"35px", fontSize:"14px"}} />
            </Row>
            <Row className='licensesLinksTop'>
              <FontAwesome name="usergroup" className={'fa-solid fa-users'} size='2x'  />
              <div className='dashboarddiv'>
                Accounts
              </div>
            </Row>
            <Row className='AccountsLinksBottom'>
              <button className='button-dashboard' onClick={() => this.onClick(8)}>
                Actieve licenties
              </button>
              <button className='button-dashboard' onClick={() => this.onClick(9)}>
                Update provider user id
              </button>
              <button className='button-dashboard' onClick={() => this.onClick(10)}>
                Zoek account
              </button>
            </Row>
            <Row className='DashboardBottomLine'>
                <FontAwesome name="line" className={''} size='2x' style={{marginLeft:"10px", marginBottom:"7px", marginTop:"20px", marginRight:"35px", fontSize:"14px"}} />
            </Row>
          </Grid>
      )
    }
  }